<script>
export default {
    name: "NursingCareNotes",

    props: {

        showModal: Boolean,
        nursingPlan: Object,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Assessment: {{ nursingPlan.assesment }}</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="flex-1">
                <h5 class="font-medium text-base">Date: {{ nursingPlan.careDate | dateFormat }}</h5></div>
            <div class="flex-1">
                <h5 class="font-medium text-base">Time: {{ nursingPlan.time }}</h5></div>
            <div class="w-full mt-2" style="max-height:50vh">
                <span v-html="nursingPlan.notes"></span>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
          class="btn-danger btn-sm text-xs rounded" 
          @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>